<template>
  <div class="Unusualapprove" v-loading="showLoading">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">处置异常审批</h4>
      </div>
      <query-tabs :query-tabs="queryTabs" :active.sync="tag"></query-tabs>
      <div class="m20">
        <customize-form
          :form-config="formConfig"
          @on-query="onQuery"
          @on-reset="onReset"
        ></customize-form>
        <customize-table
          :table-config="tableConfig"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :currentPage.sync="params.pageIndex"
        >
          <template v-slot:title="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span class="cell-link" @click="onCheck(scope.row)">{{
                  scope.row.title
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:operTypeCode="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                {{
                  scope.row.operTypeCode === '1'
                    ? '罚没保证金并公示'
                    : '不罚没不公示'
                }}
              </template>
            </el-table-column>
          </template>
          <template v-slot:reasonCode="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                {{ reasonArrs[scope.row.reasonCode] }}
              </template>
            </el-table-column>
          </template>
          <template v-slot:statusCode="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                {{
                  scope.row.statusCode === '0' &&
                  scope.row.retrieveWhether === 1
                    ? '审批不通过'
                    : statusarr[scope.row.statusCode]
                }}
              </template>
            </el-table-column>
          </template>
          <template v-slot:operations="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <el-button
                  v-show="tag === 5"
                  type="text"
                  slot="reference"
                  @click="onCheckBidFile(scope.row)"
                  >审批</el-button
                >
              </template>
            </el-table-column>
          </template>
        </customize-table>
      </div>
    </div>
  </div>
</template>
<script>
import { daterange } from '@/utils/constantime'
export default {
  name: 'ServiceExceptionApprove',
  data() {
    return {
      showLoading: false,
      removeV: 1,
      tag: 5,
      params: {
        pageIndex: 1,
        pageSize: 10
      },
      queryTabs: [
        {
          label: 5,
          name: '待审批'
        },
        {
          label: 6,
          name: '已审批'
        }
      ],
      formConfig: {
        configs: {},
        operations: [
          {
            label: '查询',
            handler: 'on-query',
            type: 'primary'
          },
          {
            label: '清空',
            handler: 'on-reset',
            type: 'default'
          }
        ]
      },
      tableConfig: {
        isPagination: true,
        columns: [],
        data: [],
        total: 0
      },
      reasonArrs: {
        '1': '买受人成交确认放弃',
        '2': '买受人成交后拒绝履行',
        '3': '处置企业原因无法执行',
        '4': '买受人未按要求完成物资交割（部分拉货）',
        '5': '其他通过非正当手段弄虚作假'
      },
      statusarr: {
        '0': '未提交',
        '1': '已提交待审批',
        '2': '审批中',
        '3': '待运营确认',
        '01': '运营审批中',
        '02': '运营审批中',
        '4': '已发布'
      }
    }
  },
  watch: {
    tag: {
      handler: function(val) {
        const basecolumns = [
          {
            label: '序号',
            type: 'index',
            width: '50px',
            align: 'center'
          },
          {
            slot: 'title',
            prop: 'title',
            label: '异常标题',
            'show-overflow-tooltip': true,
            width: '200px'
          },
          {
            prop: 'buyerCompName',
            label: '买受人',
            align: 'center',
            width: '200px'
          },
          {
            prop: 'reasonCode',
            slot: 'reasonCode',
            label: '异常类型',
            align: 'center',
            width: '200px'
          },
          {
            prop: 'operTypeCode',
            slot: 'operTypeCode',
            label: '异常处理',
            align: 'center',
            width: '200px'
          },
          {
            prop: 'noticeCode',
            label: '公告编号',
            align: 'center',
            width: '180px'
          },
          {
            prop: 'noticeTitle',
            label: '公告标题',
            align: 'center',
            width: '180px'
          },
          {
            prop: 'submitTime',
            label: '提交时间',
            align: 'center',
            width: '160px'
          },
          {
            prop: 'statusCode',
            slot: 'statusCode',
            label: '状态',
            align: 'center',
            width: '160px'
          }
        ]
        const baseForm = {
          title: {
            tag: 'input',
            label: '异常标题'
          },
          buyerCompName: {
            tag: 'input',
            label: '买受人'
          },
          operTypeCode: {
            tag: 'select',
            label: '异常处理',
            default: null,
            options: [
              { value: 1, label: '罚没保证金并公示' },
              { value: 2, label: '不罚没不公示' }
            ]
          },
          noticeCode: {
            tag: 'input',
            label: '公告编号'
          },
          noticeTitle: {
            tag: 'input',
            label: '公告标题'
          }
        }
        if (val === 5) {
          this.tableConfig.columns = [
            ...basecolumns,
            {
              slot: 'operations',
              prop: 'operations',
              label: '操作',
              width: '150px',
              align: 'center'
            }
          ]
          this.formConfig.configs = {
            ...baseForm,
            reasonCode: {
              tag: 'select',
              label: '异常类型',
              default: null,
              options: [
                { value: 1, label: '买受人成交确认放弃' },
                { value: 2, label: '买受人成交后拒绝履行' },
                { value: 3, label: '处置企业原因无法执行' },
                { value: 4, label: '买受人未按要求完成物资交割（部分拉货）' },
                { value: 5, label: '其他通过非正当手段弄虚作假' }
              ]
            },
            personName: {
              ...daterange,
              label: '提交时间'
            }
          }
        } else {
          this.formConfig.configs = {
            ...baseForm,
            statusCode: {
              tag: 'select',
              label: '操作状态',
              default: null,
              options: [
                { value: null, label: '全部' },
                { value: '0', label: '未提交' },
                { value: '1', label: '已提交待审批' },
                { value: '2', label: '审批中' },
                { value: '3', label: '待运营确认' },
                { value: '01', label: '运营审批中' },
                { value: '4', label: '已发布' },
                { value: '5', label: '审批不通过' }
              ]
            },
            reasonCode: {
              tag: 'select',
              label: '异常类型',
              default: null,
              options: [
                { value: 1, label: '买受人成交确认放弃' },
                { value: 2, label: '买受人成交后拒绝履行' },
                { value: 3, label: '处置企业原因无法执行' },
                { value: 4, label: '买受人未按要求完成物资交割（部分拉货）' },
                { value: 5, label: '其他通过非正当手段弄虚作假' }
              ]
            },
            personName: {
              ...daterange,
              label: '提交时间'
            }
          }
          this.tableConfig.columns = basecolumns
        }
        this.params = {
          pageIndex: 1,
          pageSize: 10
        }
        this.getList(val)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getList() {
      this.showLoading = true
      this.tableConfig.data = []
      this.tableConfig.total = 0
      this.params.tag = this.tag
      let data = await this.$api.serviceProvider.listAuditpunishment({
        ...this.params
      })
      this.showLoading = false
      this.tableConfig.data = data.data
      this.tableConfig.total = data.total || 0
    },
    onQuery(val) {
      this.params = {
        tag: this.tag,
        pageIndex: 1,
        pageSize: 10,
        sumitTimeStart:
          val.personName && val.personName.length != 0
            ? val.personName[0]
            : null,
        publishTimeEnd:
          val.personName && val.personName.length != 0
            ? val.personName[1]
            : null,
        title: val.title,
        buyerCompName: val.buyerCompName,
        operTypeCode: val.operTypeCode,
        noticeCode: val.noticeCode,
        noticeTitle: val.noticeTitle,
        reasonCode: val.reasonCode,
        statusCode: val.statusCode
      }
      this.getList()
    },
    onCurrentChange(val) {
      this.params.pageIndex = val
      this.getList()
    },
    onSizeChange(val) {
      this.params.pageSize = val
      this.getList()
    },
    remove(val) {
      this.removeV = val
    },
    onReset(val) {
      console.log(val)
      this.params = {
        pageIndex: 1,
        pageSize: 10
      }
      this.getList()
    },
    onCheckBidFile(o) {
      let query = {
        id: o.id,
        type: 'approve'
      }
      this.$router.push({ name: 'ServiceExceptionCheck', query })
    },
    onCheck(o) {
      let query = {
        id: o.id,
        type: 'check'
      }
      this.$openNewPage('ServiceExceptionCheck', query)
    }
  }
}
</script>
<style lang="less">
.Unusualapprove {
  .account-card {
    margin-top: 0;
    padding-top: 0;
  }
  .query-tabs {
    margin-top: 20px;
  }
  .m20 {
    margin: 20px 0;
  }
  .mb20 {
    margin-bottom: 20px;
  }
  .customize-form .el-form-item__label {
    min-width: 80px;
  }
}
</style>
